<router-outlet></router-outlet>
@if (isLoading) {
  <cck-loader></cck-loader>
}
